import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CalendarEntity,
  EducationLevel,
} from "../../services/calendar/calendar.types";

// One general calendar per education level (SCRUM-744). `null` means "not
// fetched yet" and is deliberately different from `[]`, which means "fetched
// and this level has no calendar" — the state that offers to initialize it.
export type CalendarsByLevel = Record<EducationLevel, CalendarEntity[] | null>;

export type CalendarState = {
  calendars: CalendarsByLevel;
  loading: boolean;
};

type LeveledCalendarPayload = {
  level: EducationLevel;
  calendar: CalendarEntity[];
};

const emptyCalendars = (): CalendarsByLevel => ({
  KINDER: null,
  PRIMARIA: null,
});

const initialState: CalendarState = {
  calendars: emptyCalendars(),
  loading: false,
};

const calendar = createSlice({
  name: "calendar",
  initialState,
  reducers: {
    clearCalendar: (state) => {
      state.calendars = emptyCalendars();
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCalendar: (state, action: PayloadAction<LeveledCalendarPayload>) => {
      state.calendars[action.payload.level] = action.payload.calendar;
      state.loading = false;
    },
    updateWeekInCalendar: (
      state,
      action: PayloadAction<LeveledCalendarPayload>
    ) => {
      state.calendars[action.payload.level] = action.payload.calendar;
      state.loading = false;
    },
  },
});

export default calendar;
export const { clearCalendar, setLoading, setCalendar, updateWeekInCalendar } =
  calendar.actions;
